module.exports = __webpack_public_path__ + "img/interactivebrokers.0d6cac9.png";